import { connect } from 'react-redux'
import { logoutUser } from '../actions/users'
import Header from '../components/Header'

const mapStateToProps = (state) => {
  return {
    authenticatedUser: state.users.status === 'authenticated' ? state.users.user : null
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => {
      localStorage.removeItem('automagic_token')
      dispatch(logoutUser())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)



// WEBPACK FOOTER //
// ./src/containers/Header.js